'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _MatchTooltip = require('shared/components/MatchTooltip');

var _MatchTooltip2 = _interopRequireDefault(_MatchTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Job = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Job, _Component);

  function Job() {
    (0, _classCallCheck3.default)(this, Job);
    return (0, _possibleConstructorReturn3.default)(this, (Job.__proto__ || (0, _getPrototypeOf2.default)(Job)).apply(this, arguments));
  }

  (0, _createClass3.default)(Job, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var timeout = void 0;

      var resizeProcess = function resizeProcess() {
        timeout = null;
        _this2.props.getPosition();
        _this2.getPosition();
      };

      this.props.getPosition();
      window.addEventListener('resize', function () {
        clearTimeout(timeout);
        timeout = setTimeout(resizeProcess, 500);
      });
      setTimeout(function () {
        _this2.getPosition();
        window.dispatchEvent(new Event('resize'));
      }, 100 + this.props.id * 10);
    }
  }, {
    key: 'getPosition',
    value: function getPosition() {
      var _this3 = this;

      if (this.component) {
        // set timeout, to give the component
        // a cycle to be rendered correctly.
        setTimeout(function () {
          var _component$getBoundin = _this3.component.getBoundingClientRect(),
              bottom = _component$getBoundin.bottom,
              left = _component$getBoundin.left,
              right = _component$getBoundin.right,
              height = _component$getBoundin.height,
              width = _component$getBoundin.width;

          var top = _this3.component.offsetTop + _this3.component.parentElement.offsetTop + _this3.component.parentElement.parentElement.offsetTop;

          _this3.props.getPosition({
            bottom: bottom,
            top: top,
            left: left,
            right: right,

            height: height,
            width: width
          });
        }, 20);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          title = _props.title,
          slug = _props.slug,
          subsector = _props.subsector,
          match = _props.match,
          isActive = _props.isActive;


      var className = ['role', isActive ? 'active' : null].join(' ');

      return _react2.default.createElement(
        'div',
        {
          className: className,
          ref: function ref(c) {
            _this4.component = c;
          }
        },
        _react2.default.createElement(_MatchTooltip2.default, {
          match: match,
          matchMeComponent: function matchMeComponent() {
            return _react2.default.createElement(
              'div',
              { className: 'role-percent no-match c-tooltip down' },
              _react2.default.createElement(
                'span',
                null,
                'Match'
              ),
              _react2.default.createElement(
                'em',
                null,
                'me'
              )
            );
          },
          matchComponent: function matchComponent(parsedMatch) {
            return _react2.default.createElement(
              'div',
              { className: 'role-percent c-tooltip down' },
              _react2.default.createElement(
                'em',
                null,
                parsedMatch
              ),
              _react2.default.createElement(
                'span',
                null,
                'Match'
              )
            );
          }
        }),
        _react2.default.createElement(
          'p',
          { className: 'role-title' },
          subsector,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '' + slug },
            title
          )
        )
      );
    }
  }]);
  return Job;
}(_react.Component), _class.propTypes = {
  id: _react.PropTypes.number,
  title: _react.PropTypes.string.isRequired,
  slug: _react.PropTypes.string.isRequired,
  subsector: _react.PropTypes.string.isRequired,
  match: _react.PropTypes.number,
  isActive: _react.PropTypes.bool,
  getPosition: _react.PropTypes.func.isRequired
}, _temp);
exports.default = Job;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobCareerMap/components/Job.jsx
// module id = 1172
// module chunks = 0